export default __webpack_public_path__ + "static/media/EAST1030.34I-34160_-18421_0.ef75d4e7.jpg";